exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.breadcrumb[data-v-78316544] {\n  background-color: white !important;\n  padding: 0 !important;\n}\n.breadcrumb a[data-v-78316544] {\n    color: #7F7F7F;\n}\n.disabled[data-v-78316544] {\n  color: #313131 !important;\n  cursor: not-allowed;\n  pointer-events: none;\n}\n.breadcrumb-item + .breadcrumb-item[data-v-78316544]::before {\n  float: left;\n  padding-right: 0.5rem;\n  color: #6c757d;\n  content: \">\" !important;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":false,"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"optionsId":"0","vue":true,"id":"data-v-78316544","scoped":true,"sourceMap":true}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/blogs/components/Breadcrumb.vue
// module id = 2460
// module chunks = 0